// Ported from the portal's components/Badge: same statuses, padding, radius and weight.
import * as React from "react";
import styled from "styled-components";

export type BadgeStatus = "success" | "warning" | "muted" | "danger" | "info" | "primary";

export const badgeStatuses: Record<BadgeStatus, string> = {
  success: "successSecondary",
  warning: "warningSecondary",
  muted: "gray",
  danger: "danger",
  info: "info",
  primary: "primary",
};

const BadgeStyled = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 15px;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1.1;
  &.ct-badge-sm { padding: 3px 8px; font-size: 0.7rem; }
  &.ct-badge-md { font-size: 1rem; }
  &.ct-rounded-xs { border-radius: 5px; }
`;

const capitalize = (s: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export default function Badge(props: { status: BadgeStatus; text: string; color?: string; classes?: string; style?: React.CSSProperties; size?: "sm" | "md"; rounded?: "xs"; capitalize?: boolean }) {
  const { status, text, color, classes = "", style, size, rounded } = props;
  return (
    <BadgeStyled
      className={`badge ${color ? "" : `bg-${badgeStatuses[status]}`} ${size ? `ct-badge-${size}` : ""} ${rounded ? `ct-rounded-${rounded}` : ""} ${classes}`.trim()}
      style={{ backgroundColor: color || undefined, color: color ? "#fff" : undefined, ...style }}
    >
      {props.capitalize === false ? text : capitalize(text)}
    </BadgeStyled>
  );
}
